/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import * as telemedicinaActions from '../../../../actions/telemedicinaActions';
import s from './TimerModalVideoLlamada.css';
import videoSwiss2 from '../../../../../public/images/espera.mp4';
import videoSwiss from '../../../../../public/images/video.mp4';
import ModalReprogramarTurno from '../../../../components/Telemedicina/ModalReprogramarTurno/ModalReprogramarTurno';
import TimeManipulation from '../../../../utils/timeManipulation';
import moment from 'moment';

const doctors = {
  ClinicaMedica: [
    {
      img:'ClinicaMedica/553',
      name: 'Jose Scarlatta	'
    },
    {
      img:'ClinicaMedica/749',
      name: 'Iris Salama'  
    },
    {
      img:'ClinicaMedica/24579',
      name: 'Ana Maria Videla'  
    },
    {
      img:'ClinicaMedica/19524',
      name: 'Alberto Montes'  
    },
    {
      img:'ClinicaMedica/18046',
      name: 'Ezequiel Sosa'  
    },
    {
      img:'ClinicaMedica/17991',
      name: 'Maria Marta Plaza'  
    },
    {
      img:'ClinicaMedica/17978',
      name: 'Patricia Andrea Molina'  
    },
    {
      img:'ClinicaMedica/24580',
      name: 'Eduardo Abbate'  
    }
  ],
  Pediatria: [
    {
      img:'Pediatria/24576',
      name:'Sergio Araya'
    },
    {
      img:'Pediatria/426',
      name:'Maria Isabel Alapont Montoya'
    },
    {
      img:'Pediatria/670',
      name:'Ariel Marcelo Almada'
    },
    {
      img:'Pediatria/17997',
      name:'Natalia Cristina Freitas'
    },
    {
      img:'Pediatria/24569',
      name:'Analia Jimena Bravo'
    },
    {
      img:'Pediatria/24570',
      name:'Fernanda Perez Simoes'
    },
    {
      img:'Pediatria/24574',
      name:'Maria Fernanda Rome'
    },
    {
      img:'Pediatria/24572',
      name:'Karina Grinstein'
    },
    {
      img:'Pediatria/24573',
      name:'Liliana Mariñansky'
    },
    {
      img:'Pediatria/24577',
      name:'Silvina Mazzolo'
    },
    {
      img:'Pediatria/25241',
      name:'Nora Judith Zonis'
    },
    {
      img:'Pediatria/25829',
      name:'María Florencia Fernandez'
    }
  ],
};

class TimerModalVideoLlamada extends React.Component {
  constructor(props) {
    super(props);
    this.nombreMedico = this.nombreMedico.bind(this);
    this.state = {
      medicData: '',
      interval: null,
      aproxTimeInterval: null,
      aproxTime: this.props.turnWaitingTime ? this.props.turnWaitingTime.aproxTime : ""
      //aproxTime: this.props.turnWaitingTime
    }
    this.handleWaitingScreen = this.handleWaitingScreen.bind(this);
  }

  componentWillMount(){
    this.props.admisionDePaciente(this.props.turno).then(() => {
      $('#videoSwiss').attr('src', videoSwiss);
    });
  }


  componentDidMount() {
    if(this.props.turno.tipo == 'E'){
      setInterval(this.props.aproxPeopleInQueue, 60000 * 5)
      this.props.aproxPeopleInQueue()
      const interval = setInterval(this.medicRandom, 5000)
      const aproxTimeInterval = setInterval(this.changeAproxWaitingTime, 60000 * 5);
      this.setState({interval, aproxTimeInterval})
    }
    if(this.props.admision){
      $('#videoSwiss').attr('src', videoSwiss);
    }
  }

  changeAproxWaitingTime = () => {
    const newAproxTime = TimeManipulation.changeAproxWaitingTime(this.state.aproxTime,this.state.aproxTimeInterval);
    this.setState({aproxTime: newAproxTime});
  }

  componentWillUnmount() {
    clearInterval(this.admision);
    clearInterval(this.state.interval);
  }

  formatDate(date) {
    const year = date.substring(0, 4);
    const month = date.substring(4, 6);
    const day = date.substring(6, 8);
    const hour = date.substring(8, 10);
    const min = date.substring(10, 12);
    const dateFormated = `${year}-${month}-${day} ${hour}:${min}`;
    return dateFormated;
  }

  nombreMedico = () => {
    if(this.props.turno.reemplazo && this.props.turno.reemplazo.nombreAbre){
      return this.props.turno.reemplazo.nombreAbre + " " + this.props.turno.reemplazo.apeRazon;
    }
    return this.props.turno.titular.nombreAbre + " " + this.props.turno.titular.apeRazon;
  }

  medicRandom = () => {
    let medicData
    if(this.props.turno.idEspecialidad == 200){
      medicData = doctors.Pediatria[Math.floor(Math.random() * doctors.Pediatria.length)]
      this.setState({medicData})
    }else{
      medicData = doctors.ClinicaMedica[Math.floor(Math.random() * doctors.ClinicaMedica.length)]
      this.setState({medicData})
    }
  }

  handleWaitingScreen(){
    //Agrego : a la hora para setearla a moment despues
    let horaTurno = `${this.props.turno.hora.substr(0, 2)}:${this.props.turno.hora.substr(2, 4)}`;
    const horaLimiteTurno = moment(horaTurno, 'HH:mm').add(10, 'minutes');
    let horaServer;
    
    //Inicio pantalla de espera
    if(this.props.admision && this.props.admision.clientId){
      if(this.props.IniciarLlamada != 1){
          this.props.iniciarVideoLlamada(
            $('#alertaSonora').is(':checked'),
            this.props.admision.clientId,
          ); 
      }

      //Si es programado evaluo la hora del server
      //si se pasa del +10 lo saco de la espera
      if(this.props.turno.tipo != 'E' && this.props.admision){
        horaServer = horaServer ? horaServer : moment(this.props.admision.horaServer);
        let intervaloChequeoTurno = setInterval(() => {
          let turnoExpirado = horaServer.isAfter(horaLimiteTurno);
          if(turnoExpirado && !this.props.stopInterval){
            this.props.cleanLlamada();
            $('#ModalReprogramarTurno').modal({ backdrop: 'static', keyboard: false });
            $('.modal-backdrop').hide();
            if (document.getElementById('localView')) {
              if (document.getElementById('localView').srcObject) {
                document
                  .getElementById('localView')
                  .srcObject.getTracks()
                  .forEach(track => track.stop());
                $('localView').srcObject = null;
              }
            }
            clearInterval(intervaloChequeoTurno);
          }
          //Sumo un minuto a la hora server
          horaServer = moment(horaServer).add(1, 'minutes');
        }, 60000);
      }
    }
  }

  render() {
    this.handleWaitingScreen();
    console.log(this.props.telefono);
    return (
      <div style={{ width: '100%' }}>
        {this.props.admision
          ? <div>
              <div id="datosMedico">
                <div style={{
                        margin: '20px auto',
                        borderColor: '#e4002b',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        height:'auto',
                        fontFamily: "Roboto",
                        fontSize: '20px'
                      }}>
                  {
                    this.props.turno.tipo == 'E' ?
                      <div>
                        <p style={{width:'100%'}}>
                          Especialidad: 
                          {
                            parseInt(this.props.turno.idEspecialidad) === 100 ? <span style={{color:'#FFBB24'}}> Clinica Médica</span> : <span style={{color:'#FFBB24'}}> Pediatría</span>
                          }
                        </p>
                      </div> :
                      <div>
                        {/* <p style={{marginBottom: 'initial'}}>Sos el próximo.</p>
                        <p>Serás atendido por</p> */}
                      </div>
                  }
                </div>
                <div  style={{textAlign:'center'}}>
                 <div style={{width:'100%', marginBottom:'20px'}}>
                   { this.props.turno.tipo == 'E' ?
                   this.props.numeroDePacientes == undefined || this.props.numeroDePacientes.respuesta == "999"  ? '' :
                      <div>
                        <div style={{paddingTop:'1em'}}>
                          <p style={{color:'#E4002B', fontSize:'91px', fontWeight:'800', display:'inline-block'}}>{this.props.numeroDePacientes.respuesta}</p>
                          <img src={require('../../../../../public/SVG/icon_videollamada_espera.svg')} style={{paddingBottom:'2.5em'}}/>
                        </div>
                        <p>Pacientes en espera</p>
                      </div>
                      :
                      <div></div>
                  }
                  </div>
                  {/* <p style={{fontWeight:'600',marginTop:'20px',textAlign: 'center', paddingBottom:'30px'}}> {this.state.aproxTime} </p>*/}
                  <div style={{ marginBottom:'20px', display:'flex', justifyContent:'center'}}>
                  {
                      this.props.turno.tipo == 'E' ?
                       <p>

                         Debido a la alta demanda de este servicio el tiempo de espera puede <br/> ser prolongado, también puede comunicarse con nuestra 
                         <br/> <span style={{fontWeight:'bold'}}>línea de orientación médica al 011 4363-4710. </span>
                         <br/> Por cualquier <span style={{fontWeight:'bold', color:'#E4002B'}}>urgencia comuníquese al 0800-777-7800 </span>
                         
                      </p>
                      : <p style={{fontWeight:'600',marginTop:'20px',textAlign: 'center', paddingBottom:'30px'}}> En Breve Serás Atendido </p>
                    }
                  </div>  
                    
                </div>
            </div>
              <div className="row" style={{fontSize: 'small', marginTop: '30px',paddingLeft: '59px', paddingBottom:'30px' }}>
                <label className="form-check-label d-flex align-items-center col-12">                    
                  <input
                    className="form-check-input"
                    id="alertaSonora"
                    type="checkbox"
                    value=""
                    style={{ marginRight: '1em', marginBotton:'auto'}}
                  />
                    Activar alerta sonora cuando llegue el médico
                </label>
              </div>
            </div>
          : ''}
          <ModalReprogramarTurno />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  admision: state.telemedicina.admisionado,
  turnWaitingTime: state.telemedicina.turnWaitingTime,
  IniciarLlamada: state.telemedicina.iniciar_llamada,
  telefono:state.telemedicina.telefono,
  numeroDePacientes:state.telemedicina.numeroPacientes
});

export default connect(mapStateToProps, telemedicinaActions)(
  withStyles(s)(TimerModalVideoLlamada),
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalVideoLlamada/TimerModalVideoLlamada/TimerModalVideoLlamada.js